(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sleep-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSleepCalculator = root => {
      if (!root || root.dataset.initialised === 'true') return;

      root.dataset.initialised = 'true';

      const modeInputs = root.querySelectorAll('input[name^="sleep-mode-"]');
      const ritualInputs = root.querySelectorAll('input[name^="sleep-ritual-"]');
      const timeInput = root.querySelector('[data-time-input]');
      const timeLabel = root.querySelector('[data-time-label]');
      const calculateButton = root.querySelector('[data-calculate]');
      const results = root.querySelector('[data-results]');
      const resultsTitle = root.querySelector('[data-results-title]');
      const resultsDescription = root.querySelector('[data-results-description]');
      const resultGrid = root.querySelector('[data-result-grid]');
      const recommendationCards = root.querySelectorAll('[data-recommendation]');
      const error = root.querySelector('[data-error]');
      const sleepLatency = Number(root.dataset.sleepLatency || 15);

      const normaliseMinutes = minutes => {
        return ((minutes % 1440) + 1440) % 1440;
      };

      const timeToMinutes = time => {
        const parts = time.split(':');

        if (parts.length !== 2) return null;

        const hours = Number(parts[0]);
        const minutes = Number(parts[1]);

        if (
          Number.isNaN(hours) ||
          Number.isNaN(minutes) ||
          hours < 0 ||
          hours > 23 ||
          minutes < 0 ||
          minutes > 59
        ) {
          return null;
        }

        return hours * 60 + minutes;
      };

      const formatTime = minutes => {
        const value = normaliseMinutes(minutes);
        const hours = Math.floor(value / 60);
        const mins = value % 60;

        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
      };

      const getCheckedValue = selector => {
        return root.querySelector(`${selector}:checked`)?.value || '';
      };

      const updateTimeLabel = () => {
        const mode = getCheckedValue('input[name^="sleep-mode-"]');

        timeLabel.textContent =
          mode === 'bed'
            ? 'What time would you like to go to bed?'
            : 'What time would you like to wake up?';
      };

      const createResultCard = ({ label, primaryTime, details }) => {
        const article = document.createElement('article');
        article.className = 'aa-sleep-calculator__result-card';

        const labelElement = document.createElement('p');
        labelElement.className = 'aa-sleep-calculator__result-label';
        labelElement.textContent = label;

        const timeElement = document.createElement('strong');
        timeElement.className = 'aa-sleep-calculator__result-time';
        timeElement.textContent = primaryTime;

        const detailsElement = document.createElement('p');
        detailsElement.className = 'aa-sleep-calculator__result-details';
        detailsElement.textContent = details;

        article.append(labelElement, timeElement, detailsElement);

        return article;
      };

      const showRecommendation = ritual => {
        recommendationCards.forEach(card => {
          card.hidden = card.dataset.recommendation !== ritual;
        });

        return root.querySelector(`[data-recommendation="${ritual}"]`);
      };

      const trackCompletion = (mode, ritual, recommendation) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'sleep_calculator_complete',
          calculator_mode: mode,
          ritual_preference: ritual,
          recommended_product_handle: recommendation?.dataset.productHandle || ''
        });
      };

      const calculate = () => {
        const targetMinutes = timeToMinutes(timeInput.value);

        if (targetMinutes === null) {
          error.hidden = false;
          results.hidden = true;
          return;
        }

        error.hidden = true;

        const mode = getCheckedValue('input[name^="sleep-mode-"]') || 'wake';
        const ritual = getCheckedValue('input[name^="sleep-ritual-"]') || 'bath';

        const schedules = [
          {
            label: 'Longer sleep option',
            durationMinutes: 540,
            durationLabel: '9 hours'
          },
          {
            label: 'Alternative sleep option',
            durationMinutes: 450,
            durationLabel: '7 hours 30 minutes'
          }
        ];

        resultGrid.replaceChildren();

        schedules.forEach(schedule => {
          if (mode === 'wake') {
            const sleepTime = targetMinutes - schedule.durationMinutes;
            const getIntoBedTime = sleepTime - sleepLatency;

            resultGrid.append(
              createResultCard({
                label: schedule.label,
                primaryTime: formatTime(getIntoBedTime),
                details:
                  `Get into bed at ${formatTime(getIntoBedTime)}, aim to be asleep by ` +
                  `${formatTime(sleepTime)} and wake at ${formatTime(targetMinutes)}. ` +
                  `${schedule.durationLabel} of estimated sleep.`
              })
            );
          } else {
            const sleepTime = targetMinutes + sleepLatency;
            const wakeTime = sleepTime + schedule.durationMinutes;

            resultGrid.append(
              createResultCard({
                label: schedule.label,
                primaryTime: formatTime(wakeTime),
                details:
                  `Go to bed at ${formatTime(targetMinutes)}, aim to be asleep by ` +
                  `${formatTime(sleepTime)} and wake at ${formatTime(wakeTime)}. ` +
                  `${schedule.durationLabel} of estimated sleep.`
              })
            );
          }
        });

        resultsTitle.textContent =
          mode === 'wake'
            ? 'Suggested times to begin your bedtime routine'
            : 'Suggested times to wake up';

        resultsDescription.textContent =
          `These estimates allow approximately ${sleepLatency} minutes to settle and fall asleep. ` +
          'Individual sleep needs and sleep cycle lengths vary.';

        const recommendation = showRecommendation(ritual);

        results.hidden = false;

        requestAnimationFrame(() => {
          results.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth',
            block: 'start'
          });
        });

        trackCompletion(mode, ritual, recommendation);
      };

      modeInputs.forEach(input => {
        input.addEventListener('change', updateTimeLabel);
      });

      ritualInputs.forEach(input => {
        input.addEventListener('change', () => {
          if (!results.hidden) {
            showRecommendation(input.value);
          }
        });
      });

      calculateButton.addEventListener('click', calculate);

      timeInput.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          calculate();
        }
      });

      root.querySelectorAll('[data-product-cta]').forEach(link => {
        link.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'sleep_calculator_product_click',
            recommended_product_handle:
              link.closest('[data-product-handle]')?.dataset.productHandle || ''
          });
        });
      });

      updateTimeLabel();
    };

    const initialiseAll = container => {
      const scope = container || document;

      scope
        .querySelectorAll('[data-sleep-calculator]')
        .forEach(initialiseSleepCalculator);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
    } else {
      initialiseAll(document);
    }

    document.addEventListener('shopify:section:load', event => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stress-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const outcomeCopy = {
      muscle: {
        title: 'Your body is carrying the pressure',
        description:
          'A targeted body ritual may suit you best when stress shows up through tense feeling shoulders, back, neck or legs.'
      },
      commute: {
        title: 'You need a reset on the move',
        description:
          'A portable aromatic ritual can help you create a calmer pause during crowded journeys, busy travel days or demanding transitions.'
      },
      focus: {
        title: 'Your mind needs a clearer atmosphere',
        description:
          'A home fragrance ritual may suit moments when your thoughts feel crowded and you want to create a calmer environment for focus.'
      },
      unwind: {
        title: 'You need a clearer end to the day',
        description:
          'A bath or shower ritual can create a deliberate transition between a demanding day and a slower evening.'
      },
      confidence: {
        title: 'You need a more composed ritual',
        description:
          'A reassuring aromatic ritual may suit high pressure moments when you want to feel steadier and more prepared.'
      },
      environment: {
        title: 'Your surroundings feel overstimulating',
        description:
          'A grounding aroma for your space may suit moments when noise, activity or a busy atmosphere feels difficult to leave behind.'
      }
    };

    const initialiseStressCalculator = root => {
      if (!root || root.dataset.initialised === 'true') return;

      root.dataset.initialised = 'true';

      const questionGroups = root.querySelectorAll('[data-question]');
      const calculateButton = root.querySelector('[data-calculate]');
      const restartButton = root.querySelector('[data-restart]');
      const results = root.querySelector('[data-results]');
      const resultTitle = root.querySelector('[data-result-title]');
      const resultDescription = root.querySelector('[data-result-description]');
      const recommendationCards = root.querySelectorAll('[data-recommendation]');
      const error = root.querySelector('[data-error]');

      const parseScores = value => {
        const scores = {};

        String(value || '')
          .split(',')
          .map(item => item.trim())
          .filter(Boolean)
          .forEach(item => {
            const [key, rawScore] = item.split(':');
            const score = Number(rawScore);

            if (key && Number.isFinite(score)) {
              scores[key] = score;
            }
          });

        return scores;
      };

      const getSelections = () => {
        return Array.from(questionGroups).map(group => {
          return group.querySelector('input[type="radio"]:checked');
        });
      };

      const calculateOutcome = selections => {
        const totals = {
          muscle: 0,
          commute: 0,
          focus: 0,
          unwind: 0,
          confidence: 0,
          environment: 0
        };

        selections.forEach(input => {
          const scores = parseScores(input.dataset.scores);

          Object.entries(scores).forEach(([key, score]) => {
            if (Object.prototype.hasOwnProperty.call(totals, key)) {
              totals[key] += score;
            }
          });
        });

        const priority = [
          'muscle',
          'commute',
          'focus',
          'unwind',
          'confidence',
          'environment'
        ];

        return priority.reduce((best, key) => {
          return totals[key] > totals[best] ? key : best;
        }, priority[0]);
      };

      const showRecommendation = outcome => {
        recommendationCards.forEach(card => {
          card.hidden = card.dataset.recommendation !== outcome;
        });

        return root.querySelector(`[data-recommendation="${outcome}"]`);
      };

      const scrollToResults = () => {
        requestAnimationFrame(() => {
          results.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth',
            block: 'start'
          });
        });
      };

      const trackCompletion = (selections, outcome, recommendation) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'stress_calculator_complete',
          stress_pattern: selections[0]?.value || '',
          stress_moment: selections[1]?.value || '',
          ritual_preference: selections[2]?.value || '',
          stress_outcome: outcome,
          recommended_product_handle: recommendation?.dataset.productHandle || ''
        });
      };

      const calculate = () => {
        const selections = getSelections();

        if (selections.some(input => !input)) {
          error.hidden = false;
          results.hidden = true;

          const firstMissingGroup = Array.from(questionGroups).find(group => {
            return !group.querySelector('input[type="radio"]:checked');
          });

          firstMissingGroup?.querySelector('input[type="radio"]')?.focus();
          return;
        }

        error.hidden = true;

        const outcome = calculateOutcome(selections);
        const copy = outcomeCopy[outcome];
        const recommendation = showRecommendation(outcome);

        resultTitle.textContent = copy.title;
        resultDescription.textContent = copy.description;
        results.hidden = false;

        scrollToResults();
        trackCompletion(selections, outcome, recommendation);
      };

      const restart = () => {
        root.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = false;
        });

        recommendationCards.forEach(card => {
          card.hidden = true;
        });

        error.hidden = true;
        results.hidden = true;

        root.querySelector('input[type="radio"]')?.focus();

        root.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'start'
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'stress_calculator_restart'
        });
      };

      calculateButton.addEventListener('click', calculate);
      restartButton?.addEventListener('click', restart);

      root.querySelectorAll('[data-product-cta]').forEach(link => {
        link.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'stress_calculator_product_click',
            recommended_product_handle:
              link.closest('[data-product-handle]')?.dataset.productHandle || '',
            recommended_outcome:
              link.closest('[data-recommendation]')?.dataset.recommendation || ''
          });
        });
      });
    };

    const initialiseAll = container => {
      const scope = container || document;

      scope
        .querySelectorAll('[data-stress-calculator]')
        .forEach(initialiseStressCalculator);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
    } else {
      initialiseAll(document);
    }

    document.addEventListener('shopify:section:load', event => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
